var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.src.includes('data:'))?_c('b-avatar',{attrs:{"size":_vm.size,"src":_vm.src}}):_c('b-avatar',{staticStyle:{"background-color":"transparent !important"},attrs:{"size":_vm.size,"src":_vm.photo,"variant":"light-primary"}})}
var staticRenderFns = []

export { render, staticRenderFns }